import React, { useState } from 'react';
import styles from '../../../../pages/Profile/ProfileInsights/ProfileInsights.module.css';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BasicPopup from '../../Popups/BasicPopup/BasicPopup';
import CustomDateForm from '../../../Forms/Common/CustomDateForm/CustomDateForm';
import { useFormik } from 'formik';

const columns = [
    { id: 'name', label: 'name' },
    { id: 'location', label: 'location' },
];

export const EmployerList = () => {
    const { t } = useTranslation();
    const [activeView, setActiveView] = useState('yearly');
    const profileInsights = useSelector(state => state.user.user.profileInsights);
    const [isOpenCustomDatePopup, setisOpenCustomDatePopup] = useState(false);




    const formik = useFormik({
        initialValues: {
            custom: []
        },
        onSubmit: values => { }
    });
    const filterInsights = () => {
        const now = new Date();
        const filteredInsights = profileInsights.filter((insight) => {
            const viewedAt = new Date(insight.viewed_at); // Parse `viewed_at` into a Date object
            if (activeView === 'custom' && formik.values.custom.length > 0) {
                const startDate = new Date(formik.values.custom[0].startDate);
                const endDate = new Date(formik.values.custom[0].endDate);
                return viewedAt >= startDate && viewedAt <= endDate;
            } else if (activeView === 'daily') {
                return (
                    viewedAt.toDateString() === now.toDateString() // Same day check
                );
            } else if (activeView === 'weekly') {
                const sevenDaysAgo = new Date();
                sevenDaysAgo.setDate(now.getDate() - 7);
                return (
                    viewedAt >= sevenDaysAgo && viewedAt <= now // Within the last 7 days
                );
            } else if (activeView === 'monthly') {
                const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                return (
                    viewedAt >= startOfMonth && viewedAt <= now // Current month
                );
            } else if (activeView === 'yearly') {
                const startOfYear = new Date(now.getFullYear(), 0, 1);
                return (
                    viewedAt >= startOfYear && viewedAt <= now // Current year
                );
            }
            return false;
        });
        return filteredInsights;
    };

    const filterData = filterInsights();
    const handlePopupClose = () => {
        setisOpenCustomDatePopup(false);
    }

    const handlePopupOpen = (popupName) => {
        setisOpenCustomDatePopup(true);
    }
    const handleAddEducation = (values) => {
        formik.setFieldValue('custom', [{ id: Date.now(), ...values }]);
        handlePopupClose();
    }


    const handleViewChange = (view) => {
        setActiveView(view);
        if (view == 'custom') { handlePopupOpen() }
    };

    return (
        <div className={styles.sectionWrapper} style={{ margin: '20px 0px' }}>
            {isOpenCustomDatePopup &&
                <BasicPopup
                    isOpen={isOpenCustomDatePopup}
                    closePopup={() => handlePopupClose()}
                >
                    <CustomDateForm onSubmit={handleAddEducation} />
                </BasicPopup>
            }
            <div className={styles.header} style={{ paddingBottom: '30px' }}>
                <p className={styles.heading}>{t('employerList.heading')}</p>
                <div className={styles.buttonGroup}>
                    {["custom", 'daily', 'weekly', 'monthly', 'yearly'].map((label, index) => (
                        <React.Fragment key={label}>
                            <button
                                className={
                                    activeView === label
                                        ? `${styles.button} ${styles.active}`
                                        : styles.button
                                }
                                onClick={() => handleViewChange(label.toLowerCase())}
                            >
                                {t(`profileViews.buttons.${label.toLowerCase()}`)}
                            </button>
                            {index < 3 && <div className={styles.saperator}></div>}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <div className={styles.chartContainer}>
                {filterData.length > 0 ?

                    <Paper sx={{ width: '100%', overflow: 'hidden', margin: '0 0 20px 0' }}>
                        <TableContainer sx={{ maxHeight: 300 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={'center'}
                                                style={{
                                                    width: "50%",
                                                    backgroundColor: '#F5F5F5',
                                                }}
                                            >
                                                {t(`employerList.columns.${column.label}`)}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filterData.map((row, index) => (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={index}
                                            sx={{ border: '1px solid black' }}
                                        >
                                            {columns.map((column) => {
                                                let value;
                                                if (column.id == "name") {
                                                    value = row.company_name || row.first_name;
                                                } else if (column.id == 'location') {

                                                    if (row?.country) value = t('general.country.' + row?.country);
                                                }
                                                return (
                                                    <TableCell
                                                        key={column.id}
                                                        align={'center'}
                                                        sx={{
                                                            borderTop: '0.5px solid #81B1D9',
                                                            borderBottom: '0.5px solid #81B1D9',
                                                        }}
                                                    >
                                                        {value}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                        // {/* ) */ }
                                    ))}
                                    {/* //     {/* ) : ( */}
                                    {/* //     <div className={styles.barChartNoData}>{t('employerStats.noData')}</div>

                                )} */}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                    :
                    <div className={styles.barChartNoData}>{t('employerStats.noData')}</div>

                }
            </div>
        </div>
    );
};
